type Props = {
  imageUrl?: string
}

export const getImageUrl = ({ imageUrl }: Props): string | null => {
  // Prioritize image url coming from Hygraph Assets if available
  if (imageUrl) return imageUrl

  return null
}
